import React from "react";
import { Shield, Cloud, Lock } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const TrustBar = () => {
  const { t } = useLanguage();
  const items = [
    { Icon: Shield, label: t("pricing.trust_bar.gdpr"), testId: "trust-gdpr" },
    { Icon: Cloud, label: t("pricing.trust_bar.eu_cloud"), testId: "trust-eu-cloud" },
    { Icon: Lock, label: t("pricing.trust_bar.encrypted"), testId: "trust-encrypted" },
  ];
  return (
    <div
      data-testid="trust-bar"
      className="relative border-t-2 border-b-2 border-[#1a1a1a] bg-[#0a0a0a]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-4 md:py-5 flex flex-wrap items-center justify-center gap-x-10 gap-y-3">
        {items.map(({ Icon, label, testId }) => (
          <div
            key={testId}
            data-testid={testId}
            className="inline-flex items-center gap-2.5 group"
          >
            <span className="inline-flex items-center justify-center w-7 h-7 border border-[#FFEA00]/50 bg-[#FFEA00]/[0.06] group-hover:border-[#FFEA00] transition-colors">
              <Icon className="w-3.5 h-3.5 stroke-[2.25] text-[#FFEA00]" />
            </span>
            <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#A3A3A3] group-hover:text-white transition-colors">
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
